import React, { useState } from "react";
import { Layout, Typography, Card, Row, Col, Button, Pagination, Tag, Tabs } from "antd";
import { UserOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const courses = [
    { id: 1, title: "AI Fundamentals", category: "Artificial Intelligence", difficulty: "Beginner", description: "Basic concepts in AI and machine learning.", takenBy: 150 },
    { id: 2, title: "Neural Networks", category: "Artificial Intelligence", difficulty: "Intermediate", description: "Deep dive into neural networks and their applications.", takenBy: 95 },
    { id: 3, title: "Introduction to Data Science", category: "Data Science", difficulty: "Beginner", description: "Learn the fundamentals of data science using Python.", takenBy: 200 },
    { id: 4, title: "Big Data Analytics", category: "Data Science", difficulty: "Advanced", description: "Techniques for analyzing large-scale data.", takenBy: 75 },
    { id: 5, title: "Machine Learning with Python", category: "Artificial Intelligence", difficulty: "Intermediate", description: "Using Python for building machine learning models.", takenBy: 120 },
    { id: 6, title: "Data Science with R", category: "Data Science", difficulty: "Intermediate", description: "Using R for statistical analysis and visualization.", takenBy: 110 },
    { id: 7, title: "AI Ethics and Bias", category: "Artificial Intelligence", difficulty: "Advanced", description: "Understanding AI ethics, bias, and fairness in models.", takenBy: 85 },
    { id: 8, title: "Deep Learning", category: "Artificial Intelligence", difficulty: "Advanced", description: "A comprehensive course on deep learning techniques.", takenBy: 60 },
];

const pageSize = 4;

function DataScienceAI() {
    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState("Beginner");

    const filteredCourses = courses.filter(course => course.difficulty === activeTab);
    const paginatedCourses = filteredCourses.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    return (
        <Layout>
            <Content style={{ padding: "50px" }}>
                <Title level={2}>Data Science & AI</Title>
                <Paragraph>Explore cutting-edge courses in AI and Data Science, and enhance your skills with real-world projects and challenges.</Paragraph>

                <Tabs activeKey={activeTab} onChange={key => { setActiveTab(key); setCurrentPage(1); }} centered>
                    <TabPane tab="Beginner" key="Beginner" />
                    <TabPane tab="Intermediate" key="Intermediate" />
                    <TabPane tab="Advanced" key="Advanced" />
                </Tabs>

                <Row gutter={[16, 16]}>
                    {paginatedCourses.map((course) => (
                        <Col xs={24} sm={12} md={6} key={course.id}>
                            <Card hoverable>
                                <Title level={5}>{course.title}</Title>
                                <Tag color="blue">{course.category}</Tag>
                                <Tag color={course.difficulty === "Beginner" ? "green" : course.difficulty === "Intermediate" ? "gold" : "red"}>
                                    {course.difficulty}
                                </Tag>
                                <Paragraph>{course.description}</Paragraph>
                                <Paragraph><UserOutlined /> {course.takenBy} students enrolled</Paragraph>
                                <Button type="primary">Start Course</Button>
                            </Card>
                        </Col>
                    ))}
                </Row>

                <Pagination
                    current={currentPage}
                    total={filteredCourses.length}
                    pageSize={pageSize}
                    onChange={setCurrentPage}
                    style={{ marginTop: "20px", textAlign: "center" }}
                />
            </Content>
        </Layout>
    );
}

export default DataScienceAI;
